import { render, staticRenderFns } from "./Sensory.vue?vue&type=template&id=238ddd48"
import script from "./Sensory.vue?vue&type=script&lang=js"
export * from "./Sensory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238ddd48')) {
      api.createRecord('238ddd48', component.options)
    } else {
      api.reload('238ddd48', component.options)
    }
    module.hot.accept("./Sensory.vue?vue&type=template&id=238ddd48", function () {
      api.rerender('238ddd48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/Sensory.vue"
export default component.exports